'use strict';

(function () {
  angular.module('zp').service('PostsService', postsService);

  /**ngInject */
  function postsService($http, $q, zpAPI, config, PostModel) {
    var service = this;

    var posts = [];

    service.getAll = getAll;
    service.getOne = getOne;
    service.getContent = getContent;
    service.getByAlias = getByAlias;

    function getAll() {
      if (posts && posts.length) {
        return $q.when(function () {
          return posts;
        }());
      }

      return zpAPI.http({
        method: 'GET',
        url: config.zpAPI.defaultRoutes.POSTS
      }).then(function (response) {
        var res = [];
        for (var i = 0; i < response.length; i++) {
          res.push(new PostModel(response[i]));
        }
        posts = res;
        return res;
      });
    }

    function getOne(id) {
      return zpAPI.http({
        method: 'GET',
        url: config.zpAPI.defaultRoutes.POSTS
      }).then(function (response) {
        for (var i = 0; i < response.length; i++) {
          if (response[i].id === id) {
            return new PostModel(response[i]);
          }
        }
        return null;
      });
    }

    function getByAlias(alias) {
      if (posts && posts.length) {
        return $q.when(function () {
          return posts.find(function (p) {
            return p.alias === alias;
          });
        }());
      }
      return getAll().then(function () {
        return posts.find(function (p) {
          return p.alias === alias;
        });
      });
    }

    function getContent(url) {
      return $http({
        method: 'GET',
        url: url
      }).then(function (response) {
        return response.data.content;
      });
    }
  }
})();